var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card h-100"},[_c('div',{staticClass:"card-body pb-1"},[_vm._m(0),_c('highcharts',{attrs:{"options":_vm.chartOptions}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"m-0"},[_c('small',{staticClass:"font-weight-bold"},[_vm._v("Department")])])
}]

export { render, staticRenderFns }